export const getGeoObject = (data) => {
  const {
    featureMember: [firstFound],
  } = data.response.GeoObjectCollection;

  return firstFound?.GeoObject || null;
};
